import { tv, cnMerge } from 'tailwind-variants'

type Props = {
  main: string
  sub?: string
  className?: string
}

const heading = tv({
  base: 'text-[22px] font-medium text-black leading-relaxed',
  variants: {
    bold: {
      true: 'text-[24px] font-bold',
    },
  },
})

export const BranchPageHeading: React.FC<Props> = ({ main, sub, className }) => {
  return (
    <div className={cnMerge('flex flex-col gap-1', className)()}>
      <h2 className={heading({ bold: !!sub })}>{main}</h2>
      {sub && <p className="text-[13px] text-[#828282] leading-relaxed tracking-wide">{sub}</p>}
    </div>
  )
}
